import AbEmpty from './empty';
AbEmpty.install = function(Vue) {
  Vue.component(AbEmpty.name, AbEmpty);
};
export default AbEmpty;
